/**
 * Healing Herb Shopify Theme - Main JavaScript
 * Handles animations, cart, and interactivity
 */

// Register GSAP Plugins
gsap.registerPlugin(ScrollTrigger);

// ============================================
// CUSTOM LOADER LOGIC (KINETIC)
// ============================================
window.addEventListener('load', () => {
  const tl = gsap.timeline();

  // 1. Reveal Elements
  tl.to('.loader-svg-mk2', { opacity: 1, scale: 1, duration: 1, ease: 'back.out(1.7)' })
    .to('.loader-text', { y: 0, duration: 1.2, ease: 'power3.out' }, '-=0.5')
    .to('.loader-sub', { opacity: 1, y: 0, duration: 1, ease: 'power3.out' }, '-=0.8');

  // 2. The "Curtain Reveal" Exit
  tl.to('#page-loader', {
    yPercent: -100,
    duration: 1.5,
    ease: 'power4.inOut',
    delay: 1.5,
    onStart: () => {
      if (window.heroTl) window.heroTl.play();
    }
  });
});

// Fallback in case load hangs
setTimeout(() => {
  const loader = document.getElementById('page-loader');
  if (loader && loader.getBoundingClientRect().top === 0) {
    gsap.to('#page-loader', { yPercent: -100, duration: 1, ease: 'power4.inOut' });
  }
}, 6000);

// ============================================
// LENIS SMOOTH SCROLL
// ============================================
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  direction: 'vertical',
  gestureDirection: 'vertical',
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
});

// Synchronize Lenis with GSAP ScrollTrigger
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// ============================================
// GSAP ANIMATIONS
// ============================================

// 1. Hero Reveal (Paused initially, triggered by Loader)
window.heroTl = gsap.timeline({ paused: true });
const heroTl = window.heroTl;

heroTl.from(".hero-mask", {
  clipPath: "polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)",
  duration: 1.5,
  ease: "power4.inOut"
})
  .from(".text-reveal", {
    y: "100%",
    stagger: 0.1,
    duration: 1,
    ease: "power3.out"
  }, "-=0.8")
  .to(".animate-fade", {
    opacity: 1,
    y: 0,
    duration: 0.8,
    stagger: 0.2
  }, "-=0.5")
  .to(".floating-leaf", {
    opacity: 1,
    duration: 1
  }, "-=1");

// 2. Parallax Effects
gsap.to(".parallax-img", {
  yPercent: 20,
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-image-container",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

// 3. Digesto Text Effect
gsap.to(".digesto-text", {
  scale: 1.05,
  opacity: 1,
  ease: "power2.out",
  scrollTrigger: {
    trigger: "#digesto-section",
    start: "top 70%",
    end: "bottom center",
    scrub: 1
  }
});

gsap.to(".digesto-sub", {
  y: 0,
  opacity: 1,
  duration: 1,
  scrollTrigger: {
    trigger: "#digesto-section",
    start: "top 60%"
  }
});

// 4. Product Stagger
ScrollTrigger.refresh();

gsap.to(".product-card", {
  y: 0,
  opacity: 1,
  duration: 0.8,
  stagger: 0.1,
  ease: "power3.out",
  scrollTrigger: {
    trigger: "#product-grid",
    start: "top 80%"
  }
});

// 5. Decorative Background Animations
gsap.utils.toArray('.parallax-bg').forEach(bg => {
  const speed = bg.getAttribute('data-speed') || 0.1;
  gsap.to(bg, {
    y: (i, target) => ScrollTrigger.maxScroll(window) * speed,
    ease: "none",
    scrollTrigger: {
      trigger: document.body,
      start: "top top",
      end: "bottom bottom",
      scrub: 0
    }
  });
});

// 6. Floating & Spinning Animations
gsap.to(".animate-float", {
  y: -20,
  rotation: 5,
  duration: 4,
  repeat: -1,
  yoyo: true,
  ease: "sine.inOut"
});

gsap.to(".animate-spin-slow", {
  rotation: 360,
  duration: 20,
  repeat: -1,
  ease: "linear"
});

// ============================================
// CUSTOM CURSOR LOGIC
// ============================================
const cursorDot = document.querySelector('.cursor-dot');
const cursorOutline = document.querySelector('.cursor-outline');
const interactables = document.querySelectorAll('.interactable, a, button');

if (cursorDot && cursorOutline) {
  window.addEventListener('mousemove', (e) => {
    const posX = e.clientX;
    const posY = e.clientY;

    cursorDot.style.left = `${posX}px`;
    cursorDot.style.top = `${posY}px`;

    cursorOutline.animate({
      left: `${posX}px`,
      top: `${posY}px`
    }, { duration: 500, fill: "forwards" });
  });

  interactables.forEach(el => {
    el.addEventListener('mouseenter', () => {
      cursorOutline.classList.add('hovered');
    });
    el.addEventListener('mouseleave', () => {
      cursorOutline.classList.remove('hovered');
    });
  });
}

// ============================================
// 3D TILT EFFECT LOGIC
// ============================================
const tiltCards = document.querySelectorAll('.tilt-card');

tiltCards.forEach(card => {
  card.addEventListener('mousemove', (e) => {
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -10;
    const rotateY = ((x - centerX) / centerX) * 10;

    card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
  });

  card.addEventListener('mouseleave', () => {
    card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)';
  });
});

// ============================================
// MAGNETIC BUTTON EFFECT
// ============================================
const magneticBtns = document.querySelectorAll('.magnetic-btn, .btn-hover');

magneticBtns.forEach(btn => {
  btn.addEventListener('mousemove', (e) => {
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const moveX = (x - centerX) / 3;
    const moveY = (y - centerY) / 3;

    btn.style.transform = `translate(${moveX}px, ${moveY}px)`;
  });

  btn.addEventListener('mouseleave', () => {
    btn.style.transform = 'translate(0px, 0px)';
  });
});

// ============================================
// MOBILE MENU TOGGLE
// ============================================
const menuBtn = document.getElementById('menu-btn');
const menuIcon = document.getElementById('menu-icon');
const mobileMenu = document.getElementById('mobile-menu');
const mobileLinks = document.querySelectorAll('.mobile-link');
const mobileSocials = document.querySelector('.mobile-socials');
const mobileActions = document.querySelector('.mobile-actions');
let isMenuOpen = false;

if (menuBtn) {
  menuBtn.addEventListener('click', () => {
    isMenuOpen = !isMenuOpen;

    if (isMenuOpen) {
      // Open Menu
      mobileMenu.style.pointerEvents = "auto";
      mobileMenu.style.opacity = "1";
      menuIcon.classList.remove('ph-list');
      menuIcon.classList.add('ph-x');
      menuIcon.style.color = "#F2F8EC";

      // Animate Links
      gsap.to(mobileLinks, {
        y: 0,
        opacity: 1,
        stagger: 0.08,
        duration: 0.6,
        delay: 0.1,
        ease: "power3.out"
      });

      if (mobileActions) {
        gsap.to(mobileActions, {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.4,
          ease: "power3.out"
        });
      }

      if (mobileSocials) {
        gsap.to(mobileSocials, {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.6,
          ease: "power3.out"
        });
      }

    } else {
      // Close Menu
      mobileMenu.style.pointerEvents = "none";
      mobileMenu.style.opacity = "0";
      menuIcon.classList.remove('ph-x');
      menuIcon.classList.add('ph-list');
      menuIcon.style.color = "";

      // Reset Animations
      gsap.to([mobileLinks, mobileSocials, mobileActions], {
        y: 20,
        opacity: 0,
        duration: 0.3,
        stagger: 0.05
      });
    }
  });

  // Close menu when a link is clicked
  mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
      isMenuOpen = false;
      mobileMenu.style.pointerEvents = "none";
      mobileMenu.style.opacity = "0";
      menuIcon.classList.remove('ph-x');
      menuIcon.classList.add('ph-list');
      menuIcon.style.color = "";
    });
  });
}

// ============================================
// NAVBAR SCROLL STATE
// ============================================
const navbar = document.getElementById('navbar');
if (navbar) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      navbar.classList.add('py-2');
      navbar.classList.remove('py-4');
    } else {
      navbar.classList.add('py-4');
      navbar.classList.remove('py-2');
    }
  });
}

// ============================================
// CART FUNCTIONALITY
// ============================================

// Cart Drawer Toggle
const cartToggleBtn = document.getElementById('cart-toggle-btn');
const floatingCartBtn = document.getElementById('floating-cart-btn');
const cartDrawer = document.getElementById('cart-drawer');
const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
const closeCartDrawer = document.getElementById('close-cart-drawer');

function openCartDrawer() {
  if (cartDrawer && cartDrawerOverlay) {
    cartDrawer.classList.add('is-open');
    cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
}

if (cartToggleBtn) {
  cartToggleBtn.addEventListener('click', openCartDrawer);
}

if (floatingCartBtn) {
  floatingCartBtn.addEventListener('click', openCartDrawer);
}

if (closeCartDrawer) {
  closeCartDrawer.addEventListener('click', () => {
    cartDrawer.classList.remove('is-open');
    cartDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  });
}

if (cartDrawerOverlay) {
  cartDrawerOverlay.addEventListener('click', () => {
    cartDrawer.classList.remove('is-open');
    cartDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  });
}

// Add to Cart AJAX - Single handler defined below (line ~540)
// Removed duplicate handler to prevent double cart additions

// Refresh cart drawer content and open it
function refreshAndOpenCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');

  if (!cartDrawer || !cartDrawerOverlay) return;

  // Fetch fresh cart drawer HTML
  fetch(window.location.pathname + '?sections=cart-drawer')
    .then(res => res.json())
    .then(sections => {
      if (sections['cart-drawer']) {
        // Parse the new HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

        // Get the cart drawer inner content
        const newDrawer = doc.getElementById('cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;

          // Re-attach close button listener
          const closeBtn = cartDrawer.querySelector('#close-cart-drawer');
          if (closeBtn) {
            closeBtn.addEventListener('click', () => {
              cartDrawer.classList.remove('is-open');
              cartDrawerOverlay.classList.remove('is-open');
              document.body.style.overflow = '';
            });
          }
        }
      }

      // Open the drawer
      cartDrawer.classList.add('is-open');
      cartDrawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    })
    .catch(err => {
      console.error('Error refreshing cart drawer:', err);
      // Just open the drawer without refresh
      cartDrawer.classList.add('is-open');
      cartDrawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
}

// Update Cart UI
function updateCartUI() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const headerCount = document.getElementById('header-cart-count');
      const headerTotal = document.getElementById('header-cart-total');
      const floatingCount = document.querySelector('.floating-cart-count');

      if (headerCount) headerCount.textContent = cart.item_count;
      if (headerTotal) headerTotal.textContent = formatMoney(cart.total_price);
      if (floatingCount) floatingCount.textContent = cart.item_count;
    });
}

// Format Money Helper
function formatMoney(cents) {
  if (window.Shopify && window.Shopify.money_format) {
    return window.Shopify.money_format.replace('{{amount}}', (cents / 100).toFixed(2));
  }
  return 'Rs' + (cents / 100).toFixed(2);
}

// ============================================
// RIPPLE EFFECT
// ============================================
document.querySelectorAll('.ripple').forEach(btn => {
  btn.addEventListener('click', function (e) {
    const rect = this.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'ripple-effect';
    ripple.style.left = (e.clientX - rect.left) + 'px';
    ripple.style.top = (e.clientY - rect.top) + 'px';
    this.appendChild(ripple);

    setTimeout(() => ripple.remove(), 600);
  });
});

// ============================================
// REFRESH SCROLL TRIGGER ON DYNAMIC CONTENT
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);
});

// ============================================
// PRODUCT CARD ADD TO CART (AJAX) - With Debounce Protection
// ============================================
let addToCartInProgress = false; // Debounce flag

document.addEventListener('click', function (e) {
  const addBtn = e.target.closest('.add-to-cart-btn');
  if (!addBtn) return;

  e.preventDefault();
  e.stopPropagation();

  // Debounce protection - prevent rapid double clicks
  if (addToCartInProgress || addBtn.disabled) return;
  addToCartInProgress = true;

  const variantId = addBtn.dataset.variantId;
  if (!variantId) {
    addToCartInProgress = false;
    return;
  }

  // Save original content
  const icon = addBtn.querySelector('i');
  const originalClass = icon ? icon.className : '';

  // Loading state
  addBtn.disabled = true;
  addBtn.setAttribute('aria-busy', 'true');
  if (icon) {
    icon.className = 'ph ph-spinner animate-spin text-xl';
  }

  // AJAX Add to Cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.json();
    })
    .then(item => {
      // Success state
      if (icon) {
        icon.className = 'ph-fill ph-check text-xl text-green-500';
      }
      addBtn.classList.add('bg-white', 'text-green-500');

      // Update cart count using shared function
      updateCartUI();

      // Refresh and open cart drawer using shared function
      if (typeof refreshAndOpenCartDrawer === 'function') {
        refreshAndOpenCartDrawer();
      } else {
        // Fallback if function not available
        const cartDrawer = document.getElementById('cart-drawer');
        const cartOverlay = document.getElementById('cart-drawer-overlay');
        if (cartDrawer && cartOverlay) {
          cartDrawer.classList.add('is-open');
          cartOverlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      }

      // Reset after delay
      setTimeout(() => {
        if (icon) icon.className = originalClass;
        addBtn.classList.remove('bg-white', 'text-green-500');
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
        addToCartInProgress = false;
      }, 2000);
    })
    .catch(err => {
      console.error('Add to cart error:', err);

      // Error state - show error feedback
      if (icon) icon.className = 'ph ph-x text-xl text-red-500';

      // Reset after short delay on error
      setTimeout(() => {
        if (icon) icon.className = originalClass;
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
        addToCartInProgress = false;
      }, 1500);
    });
});
